export default __webpack_public_path__ + "static/bulldog-de6f16fd8085343a9f4d6ea9c31b2e30.png";